import { Outlet } from 'react-router'

import './shell.css'

/** 로그인 셸. 콘솔·패드 공용이고 작업 줄이 없다. */
export function AuthLayout() {
  return (
    <div className="shell shell--plain">
      <div className="shell__body">
        <Outlet />
      </div>
    </div>
  )
}
